var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70412 0.999999L21.4161 1C21.6028 1 21.7819 1.07417 21.9139 1.2062C22.0459 1.33822 22.1201 1.51729 22.1201 1.704L22.1201 21.416C22.1201 21.6027 22.0459 21.7818 21.9139 21.9138C21.7819 22.0458 21.6028 22.12 21.4161 22.12L1.70412 22.12C1.51741 22.12 1.33834 22.0458 1.20632 21.9138C1.07429 21.7818 1.00012 21.6027 1.00012 21.416L1.00012 1.704C1.00012 1.51729 1.07429 1.33822 1.20632 1.2062C1.33834 1.07417 1.51741 0.999999 1.70412 0.999999Z",
    stroke: "white",
    strokeWidth: 1.716
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95918 6.27978L18.1592 6.27979M4.95918 11.5598L14.8592 11.5598M4.95918 16.8398L11.5592 16.8398",
    stroke: "white",
    strokeWidth: 1.716,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableButton);
export default __webpack_public_path__ + "static/media/tableButton.f0517467a90d456fbc51ccbcfcf30276.svg";
export { ForwardRef as ReactComponent };